import { en, type MessageKey } from './en.js';

export type { MessageKey };

const messages: Record<MessageKey, string> = en;

/** Translate a key, substituting {name} placeholders. */
export function t(key: MessageKey, vars?: Record<string, string | number>): string {
  let out: string = messages[key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) out = out.replaceAll(`{${k}}`, String(v));
  return out;
}
